module.exports = __webpack_public_path__ + "static/media/i3.09989a1c.png";